<template>
    <div>
        <p>Access settings</p>

        <div class="control">
            <label class="radio">
                <input type="radio" value="public" v-model="access"> &nbsp;
                Public: All Teamforce users can see space and request to join
            </label>
        </div>

        <div class="control">
            <label class="radio">
                <input type="radio" value="private" v-model="access"> &nbsp;
                Private: Only invited users can join space
            </label>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex';
import { copy } from '../../utils/helpers';

export default {
    name: 'SpaceSettingsAccess',
    props: ['space'],
    computed: mapState('spaces', ['update']),
    data() {
        return { access: copy(this.space.access) };
    },
    watch: {
        access(access) {
            this.$store.dispatch('spaces/update', { space_id: this.space.id, data: { access } });
        },
    },
};
</script>
